import { styled } from '@msdk/ui'

export const EmptyIcon = styled('div')`
  width: 24px;
  height: 24px;
`
